var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('transition',{attrs:{"name":"fade"},on:{"after-leave":_vm.afterLeave}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }